import React from 'react';
import { MainContainer, InputContainer, Input, ErrorText } from './styles';

export default ({
    id,
    name,
    style,
    placeholder,
    value,
    onChange,
    onBlur,
    error,
}) => {
    return (
        <MainContainer style={style}>
            <InputContainer error={error}>
                <label>{placeholder}</label>
                <Input
                    id={id}
                    name={name}
                    bordered={false}
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    error={error}
                />
            </InputContainer>
            {error && <ErrorText>{error}</ErrorText>}
        </MainContainer>
    );
};